import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const SimpleWidgetSkeleton = () => (
  <div className='box-border w-full h-[186px] rounded-[12px] flex justify-between items-start px-[24px] py-[30px] flex-col'>
    <SkeletonTheme baseColor='#DFE2EB'>
      <div className='flex flex-col h-[32px]'>
        <Skeleton width='212px' height='11px' borderRadius='13px' count={1} containerClassName='h-[11px] leading-3' />
        <Skeleton
          width='156px'
          height='11px'
          borderRadius='13px'
          count={1}
          className='mt-[10px]'
          containerClassName='h-[11px] leading-3'
        />
      </div>
      <div className='flex flex-col h-[32px]'>
        <Skeleton width='277px' height='11px' borderRadius='13px' count={1} containerClassName='h-[11px] leading-3' />
        <Skeleton
          width='277px'
          height='11px'
          borderRadius='13px'
          count={1}
          className='mt-[10px]'
          containerClassName='h-[11px] leading-3'
        />
      </div>
    </SkeletonTheme>
  </div>
);
